module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": 'Evento: ' + _vm.event.title
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Dados do Evento")]), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
    staticClass: "el-button back-button",
    attrs: {
      "to": {
        name: 'event.update.basic-data',
        params: {
          id: _vm.event.event_id
        }
      }
    }
  }, [_vm._v("\n                        Voltar para o evento pai\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "event-tabs"
  }, [_c('div', {
    staticClass: "event-tabs-links"
  }, [_c('router-link', {
    staticClass: "el-tabs__item is-top",
    attrs: {
      "to": {
        name: 'event.update.basic-data',
        params: {
          id: _vm.event.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('span', [_vm._v("Dados Gerais")])]), _vm._v(" "), _c('router-link', {
    staticClass: "el-tabs__item is-top",
    attrs: {
      "to": {
        name: 'event.update.modalities',
        params: {
          id: _vm.event.id
        }
      },
      "disabled": !_vm.event.id
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Modalidades")])]), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
    staticClass: "el-tabs__item is-top",
    attrs: {
      "to": {
        name: 'event.update.paper-types',
        params: {
          id: _vm.event.id
        }
      },
      "disabled": !_vm.event.id
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" "), _c('span', [_vm._v("Trabalhos")])]) : _vm._e(), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
    staticClass: "el-tabs__item is-top",
    attrs: {
      "to": {
        name: 'event.update.evaluations',
        params: {
          id: _vm.event.id
        }
      },
      "disabled": !_vm.event.id
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" "), _c('span', [_vm._v("Avaliações")])]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1)])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "el-card__save_form box-card"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Subeventos")]), _vm._v(" "), (_vm.event.id) ? _c('el-button', {
    staticClass: "back-button",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.createSubevent
    }
  }, [_vm._v("\n                        Criar novo Subevento\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.event.events.length > 0) ? _c('div', [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Título")]), _vm._v(" "), _c('th', [_vm._v("Data de Início")]), _vm._v(" "), _c('th', [_vm._v("Data de Término")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.event.events), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.start_datetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.end_datetime)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "160"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small",
        "title": "Duplicar Evento"
      },
      on: {
        "click": function($event) {
          _vm.cloneEvent(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone"
    })]), _vm._v(" "), (false) ? _c('router-link', {
      staticClass: "el-button el-button--primary el-button--small",
      attrs: {
        "to": {
          name: 'event.show.home',
          params: {
            id: item.id
          }
        },
        "title": "Gerenciar Evento"
      }
    }, [_c('i', {
      staticClass: "fa fa-cog"
    })]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "el-button el-button--info el-button--small",
      attrs: {
        "to": {
          name: 'event.update.basic-data',
          params: {
            id: item.id
          }
        },
        "title": "Editar Evento"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Remover Evento"
      },
      on: {
        "click": function($event) {
          _vm.deleteEvent(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  }))])]) : _c('p', [_vm._v("Nenhum sub-evento encontrado")])])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-476a5e35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/Form.vue
// module id = 745
// module chunks = 2